import { render, staticRenderFns } from "./mobile-nav-default.vue?vue&type=template&id=2e51c3d8&scoped=true"
import script from "./mobile-nav-default.vue?vue&type=script&lang=js"
export * from "./mobile-nav-default.vue?vue&type=script&lang=js"
import style0 from "./mobile-nav-default.vue?vue&type=style&index=0&id=2e51c3d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e51c3d8",
  null
  
)

export default component.exports